import * as React from 'react';
import { useAccount, State } from '@grandvisionhq/auth';
import { Card, Price, Loader, MediaQuery } from '@grandvisionhq/common';
import { useLink } from '@grandvisionhq/frk-routing';
import { Icon } from '@grandvisionhq/icons';
import { pushWishlistEvent } from '../../../data-layer/wishlist.js';

const WishlistItem = ({ removeLabel , isUpdateLoading , item , onUpdateWishList  })=>{
    const { useIsPhone  } = MediaQuery;
    const isPhone = useIsPhone();
    const authState = useAccount();
    const isUserLoggedIn = authState === State.AuthState.LoggedIn;
    const { name , sku , imageSrc , originalPrice , discountedPrice , currencyCode , slug , productType  } = item;
    const productPageHref = useLink({
        route: 'products.detail',
        params: {
            slug,
            sku,
            key: productType
        }
    }, {
        withParams: false
    });
    const onWishlistItemClick = ()=>{
        pushWishlistEvent({
            siteFeature: 'my_account',
            interactionType: 'wishlist_product_click',
            userLogged: isUserLoggedIn ? 'logged_in' : 'logged_out',
            item: {
                sku
            }
        });
    };
    return /*#__PURE__*/ React.createElement(Card, {
        layout: isPhone ? 'vertical' : 'horizontal',
        className: "wishlist-item"
    }, /*#__PURE__*/ React.createElement(Card.Image, {
        backgroundColor: "var(--color--shade-lightest)",
        alt: name,
        src: imageSrc !== null && imageSrc !== void 0 ? imageSrc : '',
        imageHref: productPageHref === null || productPageHref === void 0 ? void 0 : productPageHref.href,
        className: "wishlist-item__image",
        onClick: onWishlistItemClick
    }), /*#__PURE__*/ React.createElement(Card.Content, {
        childrenWrapperClassName: "wishlist-item__content"
    }, /*#__PURE__*/ React.createElement(Card.Section, {
        className: "wishlist-item__top-row"
    }, /*#__PURE__*/ React.createElement(Card.Heading, {
        component: "h2",
        className: "wishlist-item__title"
    }, name), /*#__PURE__*/ React.createElement(Card.Section, {
        className: "wishlist-item__prices"
    }, discountedPrice !== 0 && discountedPrice ? /*#__PURE__*/ React.createElement(Price, {
        value: discountedPrice,
        currency: currencyCode,
        size: "small",
        centAmount: false
    }) : null, originalPrice !== 0 && originalPrice ? /*#__PURE__*/ React.createElement(Price, {
        value: originalPrice,
        currency: currencyCode,
        type: discountedPrice && discountedPrice > 0 ? 'strikethrough' : 'default',
        size: "small",
        centAmount: false
    }) : null)), /*#__PURE__*/ React.createElement(Card.Section, null, isUpdateLoading ? /*#__PURE__*/ React.createElement(Loader, {
        className: "wishlist-item__loading"
    }) : /*#__PURE__*/ React.createElement("button", {
        onClick: onUpdateWishList,
        className: "wishlist-item__remove"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "trash"
    }), /*#__PURE__*/ React.createElement(Card.Text, {
        className: "wishlist-item__remove"
    }, removeLabel)))));
};

export { WishlistItem as default };
//# sourceMappingURL=WishlistItem.js.map
